import { defineComponent, ref, onMounted, openBlock, createElementBlock, withModifiers, createElementVNode, createTextVNode, createVNode, unref, createCommentVNode, createBlock, withCtx, toDisplayString, mergeProps } from "vue";
import { IconCheckSm, CdrInput, CdrButton, IconMail } from "@rei/cedar";
import BuyBoxFavoriteButton from "../BuyBoxFavoriteButton/BuyBoxFavoriteButton.mjs";
const _hoisted_1 = {
  class: "notify-me__content"
};
const _hoisted_2 = {
  "aria-live": "polite"
};
const _hoisted_3 = {
  key: 0,
  class: "notify-me__success"
};
const _hoisted_4 = {
  class: "notify-me__cta-row"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxNotifyMe",
  props: {
    email: {},
    favoriteButtonProps: {
      default: null
    },
    hasError: {
      type: Boolean
    },
    errorMessage: {},
    isNotifiedSku: {
      type: Boolean
    }
  },
  emits: ["addToWishlist", "emailUpdate", "notifyMe", "registerRef"],
  setup(__props, {
    emit: __emit
  }) {
    const emailRef = ref(null);
    const props = __props;
    const emit = __emit;
    onMounted(() => {
      var _a;
      if (!props.isNotifiedSku) {
        emit("registerRef", {
          type: "notifyMe",
          value: (_a = emailRef == null ? void 0 : emailRef.value) == null ? void 0 : _a.$el.querySelector("input")
        });
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("form", {
        class: "notify-me",
        onSubmit: _cache[2] || (_cache[2] = withModifiers(($event) => {
          var _a;
          return _ctx.$emit("notifyMe", (_a = emailRef.value) == null ? void 0 : _a.$el.querySelector("input").value);
        }, ["prevent"]))
      }, [createElementVNode("div", _hoisted_1, [_cache[5] || (_cache[5] = createElementVNode("div", {
        class: "notify-me__message"
      }, [createTextVNode(" This product is currently "), createElementVNode("span", {
        class: "notify-me__oos"
      }, "unavailable"), createTextVNode(". We can notify you as soon as it’s ready to order. ")], -1)), createElementVNode("div", _hoisted_2, [_ctx.isNotifiedSku ? (openBlock(), createElementBlock("div", _hoisted_3, [createVNode(unref(IconCheckSm), {
        class: "notify-me__check"
      }), _cache[3] || (_cache[3] = createElementVNode("div", {
        class: "notify-me__ty"
      }, " Thank you! ", -1)), _cache[4] || (_cache[4] = createElementVNode("div", {
        class: "notify-me__ty-message"
      }, " We’ll send an email when it's available. ", -1))])) : createCommentVNode("", true)]), !_ctx.isNotifiedSku ? (openBlock(), createBlock(unref(CdrInput), {
        key: 0,
        ref_key: "emailRef",
        ref: emailRef,
        name: "email",
        value: _ctx.email,
        error: _ctx.hasError,
        label: "Email",
        autocomplete: "email",
        required: "",
        onBlur: _cache[0] || (_cache[0] = (e) => _ctx.$emit("emailUpdate", e.target.value))
      }, {
        error: withCtx(() => [createTextVNode(toDisplayString(_ctx.errorMessage), 1)]),
        _: 1
      }, 8, ["value", "error"])) : createCommentVNode("", true)]), createElementVNode("div", _hoisted_4, [createVNode(unref(CdrButton), {
        disabled: _ctx.isNotifiedSku,
        "full-width": true,
        class: "notify-me__button",
        type: "submit",
        modifier: "dark"
      }, {
        "icon-left": withCtx(() => [createVNode(unref(IconMail), {
          "inherit-color": ""
        })]),
        default: withCtx(() => [_cache[6] || (_cache[6] = createTextVNode(" Notify me "))]),
        _: 1
      }, 8, ["disabled"]), createVNode(unref(BuyBoxFavoriteButton), mergeProps(_ctx.favoriteButtonProps, {
        type: "button",
        class: "notify-me__favorite-button",
        onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.$emit("addToWishlist"), ["prevent"]))
      }), null, 16)])], 32);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxNotifyMe2.mjs.map
